module.exports = __webpack_public_path__ + "img/GAME_BUTTERFLY.d94df4f8.jpg";